import React from 'react';
import { Game } from '../../types/types';
import { BuildGamesTable, PlayerGamesColumns, } from '../../globals/TableFunctions';
import TableContainer from '../Tables/TableContainer';
import PlayerDataGrid from '../DataGrid/PlayerDataGrid';

export interface Props {
    games: Game[];
    title: string;
}

function PerformanceSelectedGames({games, title}:Props) {
    let rows = BuildGamesTable(games);
    return <TableContainer header={title}>
        <PlayerDataGrid
            columns={PlayerGamesColumns}
            rows={rows}
            height={500}
            onCellClick={e => console.log("")}
        />
    </TableContainer>
}

export default PerformanceSelectedGames;